import CustomElement from '../core/custom.js';
import Emitter from '../core/emitter.js';

export default window.customElements.define('cursor-trigger', class extends CustomElement {
    constructor() {
        super();

        this._onMouseEnter = this.onMouseEnter.bind(this)
        this._onMouseLeave = this.onMouseLeave.bind(this)
    }

    connectedCallback() {
        super.connectedCallback()

        this._name = this.getAttribute('data-name') ?? null

        if (this._name) {
            this.addEventListener('mouseenter', this._onMouseEnter)
            this.addEventListener('mouseleave', this._onMouseLeave)
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        if (this._name) {
            this.addEventListener('mouseenter', this._onMouseEnter)
            this.addEventListener('mouseleave', this._onMouseLeave)
        }
    }

    onMouseEnter() {
        Emitter.emit('cursor:enter', this._name)
    }

    onMouseLeave() {
        Emitter.emit('cursor:leave', this._name)
    }
});